var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "device-transfers-view" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "device-transfers-container",
      },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.deviceTransfers },
          },
          [
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("dos.device_transfers.columns.device_id"),
                prop: "device_id",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("dos.device_transfers.columns.mac_address"),
                prop: "mac_address",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("dos.device_transfers.columns.status"),
                prop: "transfer_status",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("dos.device_transfers.columns.old_owner_id"),
                prop: "old_owner_id",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("dos.device_transfers.columns.new_owner_id"),
                prop: "new_owner_id",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("dos.device_transfers.columns.reason"),
                prop: "reason",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("dos.device_transfers.columns.start_date"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatDate(scope.row.start_date)) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: _vm.$t("dos.device_transfers.columns.end_date") },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatDate(scope.row.end_date)) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("template", { slot: "empty" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("dos.device_transfers.empty")) +
                  "\n      "
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }